module.exports = __webpack_public_path__ + "img/android_chrome.fac36478.gif";